"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash.isequal"));

var _consts = require("../consts");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BaseIntervalFrequency = /*#__PURE__*/function () {
  function BaseIntervalFrequency(frequency, customFrequency) {
    var isCustom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _classCallCheck(this, BaseIntervalFrequency);

    _defineProperty(this, "frequency", void 0);

    _defineProperty(this, "customFrequency", void 0);

    _defineProperty(this, "isCustom", void 0);

    this.frequency = frequency;
    this.customFrequency = customFrequency;
    this.isCustom = isCustom;
  }

  _createClass(BaseIntervalFrequency, [{
    key: "isBiannualPermutation",
    value: function isBiannualPermutation() {
      var every = this.customFrequency.every;
      return this.frequency === _consts.IntervalFrequencyEnum.MONTH && every === 6;
    }
  }, {
    key: "isQuarterPermutation",
    value: function isQuarterPermutation() {
      var every = this.customFrequency.every;
      return this.frequency === _consts.IntervalFrequencyEnum.MONTH && every === 3;
    }
  }, {
    key: "isMonthlyPermutation",
    value: function isMonthlyPermutation() {
      var every = this.customFrequency.every;
      return this.frequency === _consts.IntervalFrequencyEnum.MONTH && every === 1;
    }
  }, {
    key: "isWeeklyPermutation",
    value: function isWeeklyPermutation() {
      return this.frequency === _consts.IntervalFrequencyEnum.WEEK;
    }
  }, {
    key: "isLow",
    value: function isLow() {
      var weeklyValue = _consts.FrequencyBaseValue[_consts.IntervalFrequencyEnum.WEEK];
      var valueOf = this.valueOf();
      return valueOf < weeklyValue && valueOf !== 0;
    }
  }, {
    key: "isHigh",
    value: function isHigh() {
      var twiceMonthlyValue = _consts.FrequencyBaseValue[_consts.IntervalFrequencyEnum.TWICE_MONTH];
      return this.valueOf() > twiceMonthlyValue;
    }
  }, {
    key: "isVeryHigh",
    value: function isVeryHigh() {
      var twiceDailyValue = _consts.FrequencyBaseValue[_consts.IntervalFrequencyEnum.DAY] * 2;
      return this.valueOf() > twiceDailyValue;
    }
  }, {
    key: "hasDueDate",
    value: function hasDueDate() {
      return this.frequency !== _consts.IntervalFrequencyEnum.AS_NEEDED;
    }
  }, {
    key: "numberOfEvents",
    value: function numberOfEvents() {
      return this.customFrequency.numberOfEvents;
    }
  }, {
    key: "getInterval",
    value: function getInterval(date) {
      var interval = this.getMicroIntervals({
        start: date,
        end: date
      });
      var first = interval[0];
      return first || null;
    }
    /**
     * @param fullInterval
     * @param defaultStartMonth - zero-indexed month to start generating micro-intervals for,
     *  e.g. `6` for CA SWPPP year's start month (July).
     * @param defaultStartDay - one-indexed day of month to start generating micro-intervals for,
     *  e.g. startMonth = 2, startDay = 15 for March 15
     */

  }, {
    key: "getMicroIntervals",
    value: function getMicroIntervals(fullInterval) {
      var defaultStartMonth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var defaultStartDay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      if (this.numberOfEvents() === 0) {
        return [];
      }

      var _this$customFrequency = this.customFrequency,
          startMonth = _this$customFrequency.startMonth,
          startDay = _this$customFrequency.startDay;
      var month = startMonth != null ? startMonth : defaultStartMonth;
      var day = startDay != null ? startDay : defaultStartDay;
      var intervals = [];
      var currentStart = this.getStartOfInterval(fullInterval.start, month, day);
      var nextStart = new Date(currentStart.getTime());

      while (nextStart <= fullInterval.end) {
        nextStart = this.addIntervals(currentStart, 1, day);
        intervals.push({
          start: new Date(currentStart.getTime()),
          end: new Date(nextStart.getTime() - 1),
          frequency: this.frequency,
          customFrequency: this.customFrequency,
          excluded: !this.isIncludedInRepeat(currentStart)
        });
        currentStart = nextStart;
      }

      return intervals;
    }
  }, {
    key: "valueOf",
    value: function valueOf() {
      var _this$customFrequency2 = this.customFrequency,
          numberOfEvents = _this$customFrequency2.numberOfEvents,
          every = _this$customFrequency2.every;
      var baseValue = _consts.FrequencyBaseValue[this.frequency];
      return baseValue / every * (numberOfEvents > 1 ? 2 : 1);
    }
  }, {
    key: "sameAs",
    value: function sameAs(other) {
      var normalized = this.normalizeFrequency();
      var otherNormalized = other.normalizeFrequency();
      return this.frequency === other.frequency && (0, _lodash["default"])(normalized, otherNormalized);
    }
  }, {
    key: "lastDayOfMonth",
    value: function lastDayOfMonth(year, month) {
      return new Date(year, month + 1, 0).getDate();
    }
  }, {
    key: "dayOrLastDayOfMonth",
    value: function dayOrLastDayOfMonth(year, month, day) {
      var lastDayOfMonth = this.lastDayOfMonth(year, month);
      return day > lastDayOfMonth ? lastDayOfMonth : day;
    }
    /**
     * Sets the day or the last day of the month if the day is greater than the month's last day.
     *
     * @param date The Date object
     * @param day A numeric value equal for the day of the month.
     */

  }, {
    key: "setDateOrLastDayOfMonth",
    value: function setDateOrLastDayOfMonth(date, day) {
      var year = date.getFullYear();
      var month = date.getMonth();
      date.setDate(this.dayOrLastDayOfMonth(year, month, day));
      return date;
    }
    /**
     * Sets the month and day (or the last day of the month if the day is greater than the month's last day).
     *
     * @param date The Date object
     * @param month A zero-based numeric value for the month (0 for January, 11 for December). Must be specified if numDate is specified.
     * @param day A numeric value equal for the day of the month.
     */

  }, {
    key: "setMonthExact",
    value: function setMonthExact(date, month, day) {
      var year = date.getFullYear();
      var dayToSet = this.dayOrLastDayOfMonth(year, month, day == null ? date.getDate() : day);
      date.setMonth(month, dayToSet);
      return date;
    }
    /**
     * Sets the year, month and day (or the last day of the month if the day is greater than the month's last day).
     *
     * @param date The Date object
     * @param year A numeric value for the year.
     * @param month A zero-based numeric value for the month (0 for January, 11 for December). Must be specified if numDate is specified.
     * @param day A numeric value equal for the day of the month.
     */

  }, {
    key: "setYearExact",
    value: function setYearExact(date, year, month, day) {
      var monthToSet = month == null ? date.getMonth() : month;
      var dayToSet = this.dayOrLastDayOfMonth(year, monthToSet, day == null ? date.getDate() : day);
      date.setFullYear(year, monthToSet, dayToSet);
      return date;
    }
    /**
     * Creates a new Date with the specified year, month and day (or the last day of the month if the day is greater than the month's last day)
     *
     * @param year A numeric value for the year.
     * @param month A zero-based numeric value for the month (0 for January, 11 for December).
     * @param day A numeric value equal for the day of the month.
     */

  }, {
    key: "getDateExactMonth",
    value: function getDateExactMonth(year, month, day) {
      var date = new Date(year, month, day);

      if (date.getMonth() > month) {
        date.setMonth(month + 1, 0);
      }

      return date;
    } // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "isIncludedInRepeat",
    value: function isIncludedInRepeat(date) {
      return true;
    }
  }, {
    key: "normalizeFrequency",
    value: function normalizeFrequency() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _this$customFrequency3 = this.customFrequency,
          nonCustomFrequency = _this$customFrequency3.nonCustomFrequency,
          props = _objectWithoutProperties(_this$customFrequency3, ["nonCustomFrequency"]);

      var normalized = _objectSpread({
        canAddMore: false,
        startMonth: 0,
        startDay: 1,
        repeatOn: []
      }, props);

      if (normalized.repeatOn && normalized.repeatOn.length) {
        var maxLength = 0;

        switch (this.frequency) {
          case _consts.IntervalFrequencyEnum.DAY:
            maxLength = 7;
            break;

          case _consts.IntervalFrequencyEnum.MONTH:
            maxLength = 12 / normalized.every;
            break;

          default:
            maxLength = 0;
            break;
        }

        normalized.repeatOn = normalized.repeatOn.length === maxLength ? [] : _toConsumableArray(normalized.repeatOn).sort();
      }

      return normalized;
    }
  }]);

  return BaseIntervalFrequency;
}();

exports["default"] = BaseIntervalFrequency;